module.exports = require("react-chartjs-2");